const buildQuery = (query) => {
  return Object.entries(query)
    .map(([key, value]) => {
      return `${key}=${normalizeValue(value)}`;
    })
    .join('&');
};

export default buildQuery;

const normalizeValue = (value) => {
  if (!value || (typeof value === 'object' && !value.value)) {
    return '';
  }

  if (typeof value === 'object') {
    return value.value;
  }

  return value;
};
